import * as ServerComms from './ServerComms';


export function openUrl(url){
    return function(e){
       window.open(url);
    }
  }

export function mainOverviewFn(height, width){
  return {
    height,
    width, 
    position: "absolute",
    top: 0, 
    bottom: 0,
    left: 0,
    right: 0,
  }
}

export function downloadFile(name, csv){
    var textFile = null,
    makeTextFile = function (text) {
      var data = new Blob([text], {type: 'text/plain'});

      // If we are replacing a previously generated file we need to
      // manually revoke the object URL to avoid memory leaks.
      if (textFile !== null) {
        window.URL.revokeObjectURL(textFile);
      }

      textFile = window.URL.createObjectURL(data);

      // returns a URL you can use as a href
      return textFile;
    };   
      var link = document.createElement('a');
      link.setAttribute('download', name);
      link.href = makeTextFile(csv);
      document.body.appendChild(link);

      // wait for the link to be added to the document 
        var event = new MouseEvent('click');
        link.dispatchEvent(event);
        document.body.removeChild(link);
}



export function adminActionFullFn(setIsSubmittingWhat, setIsSubmitting, sessionID, subdomainID, clickLogOut){  
  return function adminActionFull(requestType, formulaUriToAdd, postPostFunction, userSubdomainIDIn, vPasswordIn, files){

    var failFunction = function(){
      setIsSubmitting(false);
      setIsSubmittingWhat("");
      console.log(requestType);
      console.log(formulaUriToAdd);
      console.log("Fail");
    }

    setIsSubmitting(true);

    var postFunction = function(response){
      setIsSubmitting(false);
      setIsSubmittingWhat("");
      if (response.t === "atom" && response.v === "noSuchAccount"){
        clickLogOut();
        return;
      }
      if (response.t === "tuple"){
        if (response.v[0].v === "error"){
          window.alert(response.v[1].v);
          return;
        }
      }

      if (postPostFunction){
        postPostFunction(response);
      }
    }

      var passObject = {
        fn:"spec",
        requestType,
        formulaUriToAdd,
        sessionID,
        userSubdomainID:userSubdomainIDIn,
        vPassword:vPasswordIn,
        subdomainID,
      };

      if (!files){
        files = [];
      }
      
     ServerComms.fetchSomethingNoJson(passObject, postFunction, failFunction, files);     
    }
}

export function getSessionIDEtc(sessionIDUserSubdomainIDVPassword){
  var sessionID = +sessionIDUserSubdomainIDVPassword.split(" ")[0];
  var userSubdomainID = +sessionIDUserSubdomainIDVPassword.split(" ")[1];
  var vPassword = sessionIDUserSubdomainIDVPassword.split(" ")[2];
  return {sessionID, userSubdomainID, vPassword};

}

export function backgroundColor(){
  return "#FFEDD9";
}

export function fromCharCode(x){
      return String.fromCharCode(x)
}

export function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}


export function convertToGrid(lines, size, fillGaps){
    var smallArray = [];
    if (lines){
      for (var i=0; i< lines.length; i+=size) {
          smallArray.push(lines.slice(i,i+size));
          // do something with smallarray
      }
      if (fillGaps){
        if (smallArray.length > 0){
          var last = smallArray[smallArray.length-1];
          if (last){
            var nowLength = last.length;
            for (var j = nowLength; j < size; j++){
              last.push("");
            }            
          }
        }      
      }      
    }

  return smallArray;  
}


export function textReader(textList){
  return textList.map((aText, index)=>{
    if (aText.v[0].v === "s"){
      return aText.v[1].v;
    }else if (aText.v[0].v === "a"){
      return aText.v[1].v;
    }else{
      return "";
    }
  }).join("");
}

export function convertLevels(levels){
    return levels.map((aLevel, index)=>{
      return {v:aLevel};      
    })
  }

